/**
 * InfoIcon/index.js
 * desc: content info icon
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const InfoIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="info icon" label={ tooltip || translate('icons.info.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm1.2-17.4v2.16h-2.4V6.6h2.4zm0 4.32v6.48h-2.4v-6.48h2.4z"/></svg>
    </IconButton>
);


export default InfoIcon;
